import { useFlags } from '@missionlabs/feature-flags'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { SubNavLink, SubNavMenu } from 'shared/components/SubNav'
import { Features, useHasClientFeature } from 'shared/hooks/useHasClientFeature'

export interface SettingsSidebarProps {}

export const SettingsSidebar: FC<SettingsSidebarProps> = () => {
    const { t } = useTranslation()
    const flags = useFlags(['settings_conference_calls', 'speed_dial'])

    const isIntegrationClientEnabled = useHasClientFeature(Features.integrations)

    return (
        <SubNavMenu title={t('settings.title')}>
            <SubNavLink label={t('settings.myDetails')} page="/settings/my-details" />
            <SubNavLink label={t('settings.myNumbers')} page="/settings/my-numbers" />
            <SubNavLink label={t('settings.calls')} page="/settings/calls" />
            <SubNavLink label={t('settings.devices')} page="/settings/devices" />
            {flags.speed_dial.enabled && (
                <SubNavLink label={t('settings.speedDial.title')} page="/settings/speed-dial" />
            )}
            <SubNavLink label={t('settings.sounds.title')} page="/settings/sounds" />
            {isIntegrationClientEnabled && (
                <SubNavLink label={t('admin.integrations.title')} page="/settings/integrations" />
            )}
            <SubNavLink label={t('settings.recordings')} page="/settings/recordings" />
            <SubNavLink label={t('settings.notifications')} page="/settings/notifications" />
            {flags.settings_conference_calls.enabled && (
                <SubNavLink
                    label={t('settings.conferenceCalling')}
                    page="/settings/conference-calling"
                />
            )}
        </SubNavMenu>
    )
}
